import React, { useEffect, useState } from "react";
import _ from "lodash";

import styles from "./VariablePage.module.scss";

import { useSelector, useDispatch } from "react-redux";
import { fetchConstantThunk, setValue, updateConstantThunk } from "../../features/ConstantReducer";

import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Switch } from 'antd';
const antIcon = <LoadingOutlined style={{ fontSize: 12, color: "white" }} spin />;
const toggleAntIcon = <LoadingOutlined style={{ fontSize: "20px", color: "white" }} spin />;



export default function VariablePage() {

    const { data, status } = useSelector(state => state.constantManagement);
    const dispatch = useDispatch();

    useEffect(() => {
        if (status !== "success") {
            dispatch(fetchConstantThunk());
        }
    }, [])




    function handleChange(e) {
        const { name, value } = e.target;

        const val = parseFloat(value);

        if (val) {
            return dispatch(setValue({
                [name]: val
            }
            ));
        }
        else {
            return dispatch(setValue({
                [name]: 0
            }
            ));
        }
    }

    function handleIntegerChange(e) {
        const { name, value } = e.target;

        const val = parseInt(value);

        if (val) {
            return dispatch(setValue({
                [name]: val
            }
            ));
        }
        else {
            return dispatch(setValue({
                [name]: 0
            }
            ));
        }
    }

    function handleToggleChange(name, value) {
        return dispatch(setValue({
            [name]: value
        }
        ));
    }

    function handleSubmit() {
        if (!_.isEmpty(data))
            dispatch(updateConstantThunk());
    }

    return (
        <div className={styles.variablePage}>
            <h1 className={styles.contentTitle}>Update Coin Setup</h1>
            <div className={styles.content}>
                <div className={styles.row}>
                    <h2>
                        Coins Per View
                    </h2>
                    <div className={styles.updateInput}>
                        {
                            status !== "success" ? <div className={styles.input}><Spin indicator={antIcon} size="large" /></div> :
                                <input
                                    type="number"
                                    value={parseInt(data.cash_per_view).toString()}
                                    onChange={handleIntegerChange}
                                    placeholder="Enter Coins Per View"
                                    name="cash_per_view" className={styles.input}
                                    onKeyDown={(evt) => ["."].includes(evt.key) && evt.preventDefault()}
                                />
                        }
                    </div>
                </div>
                <div className={styles.row}>
                    <h2>
                        Exchange Rate
                    </h2>
                    <div className={styles.updateInput}>
                        {
                            status !== "success" ? <div className={styles.input}><Spin indicator={antIcon} size="large" /></div> :
                                <input type="number" value={parseFloat(data.exchange_rate).toString()} onChange={handleChange} placeholder="Enter Exchange Rate" name="exchange_rate" className={styles.input} />
                        }
                    </div>
                </div>
                <div className={styles.row}>
                    <h2>
                        Invite Coins
                    </h2>
                    <div className={styles.updateInput}>
                        {
                            status !== "success" ? <div className={styles.input}><Spin indicator={antIcon} size="large" /></div> :
                                <input
                                    type="number"
                                    value={parseInt(data.invite_coins).toString()}
                                    onChange={handleIntegerChange}
                                    placeholder="Enter Exchange Rate"
                                    name="invite_coins"
                                    className={styles.input}
                                    onKeyDown={(evt) => ["."].includes(evt.key) && evt.preventDefault()}
                                />
                        }
                    </div>
                </div>
                <div className={styles.row}>
                    <h2>
                        In-App Coins
                    </h2>
                    <div className={styles.toggleContainer}>
                        <p className={styles.toggleLabel}>False</p>
                        <div className={styles.toggleButton}>
                            {status !== "success" ?
                                <Spin indicator={toggleAntIcon} size="large" /> :
                                <Switch checked={data?.inApp_coins} onChange={(value) => handleToggleChange('inApp_coins', value)} />
                            }</div>
                        <p className={styles.toggleLabel}>True</p>

                    </div>
                </div>
                <button className={styles.submit} onClick={handleSubmit}>
                    Save
                </button>

            </div>

        </div>
    )
}